export default __webpack_public_path__ + "static/B0191-b50cbe5e00422ff40f22c820839c111a.png";